<template>
	<tr>
		<td data-th="Product">
			<div class="row">
				<!-- <div class="col-sm-2 d-none d-sm-block">
					<img :src="cartItem.picUrl" alt="..." class="img-fluid"/>
				</div> -->
				<div class="col-sm-10">
					<h6 class="nomargin">{{ cartItem.title }}</h6>
					<!-- <p>{{ cartItem.description }}</p> -->
				</div>
			</div>
		</td>
		<td v-if="showPrices" data-th="Price">{{ (cartItem.price * ( 1 + cartItem.taxrate / 100)).toFixed(2) }}</td>
		<td data-th="Quantity">
			<input type="number" class="form-control text-center"
				:value="cartItem.quantity"
				@input="updateQuantity"
				min="0">
		</td>
		<td v-if="showPrices" data-th="Subtotal" class="text-center"> {{ subtotal }}</td>
		<td class="actions" data-th="">
			<button class="btn btn-danger btn-sm" @click="removeItem"><i class="fa fa-trash-o"></i></button>
		</td>
	</tr>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	export default {
		props: ['cartItem'],
		computed: {
			...mapGetters(['showPrices']),

			subtotal() {
				let amt = this.cartItem.quantity * (this.cartItem.price * ( 1 + this.cartItem.taxrate / 100)).toFixed(2)
				return amt.toFixed(2)
			}
		},
		methods: {
			...mapActions(['updateCart', 'removeItemInCart']),
			removeItem() {
				let vm = this;
				this.removeItemInCart({
					item: vm.cartItem
				});
			},
			updateQuantity(event) {
				let vm = this;
				if (!event.target.value)
					event.target.value = "0"
				this.updateCart({
					item: vm.cartItem,
					quantity: parseFloat(event.target.value),
					isAdd: false
				});
			}
		}
	}
</script>
